import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/auth/Context";
import { getAccessExceptionsRequest } from "../requests/accessControl";
import { ACCESS_CONTROL_QUERY_KEYS } from "../../query/keys";
import { CACHE_TIMES } from "../../query/options";

const DEFAULT_LIMIT = 10;

export interface UseAccessExceptionsOptions {
  enabled?: boolean;
}

export const useAccessExceptions = (
  limit: number = DEFAULT_LIMIT,
  options: UseAccessExceptionsOptions = {},
) => {
  const { token } = useAuth();
  const { enabled: enabledOption = true } = options;

  return useQuery({
    queryKey: [...ACCESS_CONTROL_QUERY_KEYS.exceptions(), limit],
    queryFn: () => getAccessExceptionsRequest(token!, limit),
    enabled: !!token && enabledOption,
    ...CACHE_TIMES.TRANSACTIONAL_DATA,
  });
};
